import { webApiWithResponse } from "../../../../core/http/httpThunks";
import { Warehouse } from "../types";

export const createWhsApi = (userId: string, whs: Warehouse) =>
  webApiWithResponse<string>({
    method: "PUT",
    url: "listing/newwhs",
    params: {
      userId,
    },
    data: whs,
  });

export default createWhsApi;
